import { Stack } from "@mui/material";
import CapitalTabs from "./tabs";

const Capital = () => {
  return (
    <Stack spacing={3}>
      <CapitalTabs />
    </Stack>
  );
};

export default Capital;
